import React from 'react';
export function Footer() {
  return <footer className="w-full bg-[#030308] py-16 px-4 border-t border-white/5" data-id="element-104">
      <div className="max-w-4xl mx-auto text-center" data-id="element-105">
        <div className="text-white text-3xl font-black tracking-widest mb-6 flex items-center justify-center gap-3" data-id="element-106">
          <span className="text-4xl" data-id="element-107">🎨</span> EDULABS™ Deutschland
        </div>

        <p className="text-white/80 text-lg leading-relaxed mb-3 max-w-xl mx-auto font-medium" data-id="element-108">
          Exzellenz-Ressourcen für den Volleyballsport.
        </p>
        <p className="text-white/70 text-sm italic mb-10" data-id="element-109">
          Weil Coaching dich nicht deine Freizeit kosten sollte.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-white/80 mb-10" data-id="element-110">
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-111">
            <span data-id="element-112">📧</span> support.edulabs@gmail.com
          </span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-113">
            <span data-id="element-114">📲</span> @volleyballbereit.de
          </span>
          <span className="hover:text-white transition-colors cursor-pointer flex items-center gap-2" data-id="element-115">
            <span data-id="element-116">🌐</span> www.volleyballbereit.de
          </span>
        </div>

        <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-8 w-full max-w-lg mx-auto" data-id="element-117" />

        <p className="text-white/60 text-xs tracking-wider" data-id="element-118">
          © EDULABS™ 2026 — Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>;
}